'use client';

import { useShallow } from 'zustand/react/shallow';
import { usePortalCtx } from '~/features/global/portal';
import { useActivitySearchModeStore } from './activity-search-mode-store';
import type { ActivitySearchMode } from './shared';

/**
 * AI Search is website-only for now. The BIZZ booking portal hides the AI
 * toggle/tabs and never enters AI mode — the AI retrieval path doesn't yet
 * honour bizz-exclusive categories, bizz pricing rules, and per-tenant
 * constraints the way the classic grid does (see ai-docs/README.md).
 */
export function useAiSearchEnabled(): boolean {
    return usePortalCtx().portal !== 'BIZZ';
}

export function useActivitySearchMode(): {
    mode: ActivitySearchMode;
    setMode: (mode: ActivitySearchMode) => void;
    isAi: boolean;
    isNormal: boolean;
} {
    return useActivitySearchModeStore(
        useShallow(s => ({
            mode: s.mode,
            setMode: s.setMode,
            isAi: s.mode === 'ai',
            isNormal: s.mode === 'normal',
        })),
    );
}
